export var addIf = function addIf(condition, toAdd) {
  return condition ? [toAdd] : [];
};